<!-- calendar-navigation.html -->
<div class="calendar-navigation-page">
  <app-header></app-header>

  <!-- Container principal -->
  <div class="navigation-wrapper">
    <!-- Breadcrumb fora do card -->
    <div class="breadcrumb-container">
      <div class="breadcrumb">
        <a (click)="navigateToHome()" class="breadcrumb-item">Tela inicial</a>
        <span class="breadcrumb-separator">></span>
        <span class="breadcrumb-item active">Agendamentos</span>
      </div>
    </div>

    <!-- Container do conteúdo (CARD BRANCO) -->
    <div class="calendar-content-wrapper">
      <!-- Conteúdo dentro do card -->
      <div class="calendar-content">

        <!-- Título DENTRO do card -->
        <h1 class="page-title-main">{{ getTitle() }}</h1>

        <!-- Contador de agendamentos DENTRO do card -->
        <div class="appointments-counter">
          <div *ngIf="isLoading" class="counter-loading">
            <div class="loading-spinner"></div>
            <span>Carregando...</span>
          </div>
          <p *ngIf="!isLoading" class="counter-text">{{ appointmentsCount }} agendamentos encontrados</p>
        </div>

        <!-- Navigator Menu DENTRO do card -->
        <div class="navigator-menu">
          <button
            class="nav-tab"
            [class.active]="currentPeriod === 'day'"
            (click)="selectPeriod('day')">
            Dia
          </button>
          <button
            class="nav-tab"
            [class.active]="currentPeriod === 'week'"
            (click)="selectPeriod('week')">
            Semana
          </button>
          <button
            class="nav-tab"
            [class.active]="currentPeriod === 'month'"
            (click)="selectPeriod('month')">
            Mês
          </button>
        </div>

        <!-- Área para o conteúdo dos calendários -->
        <div class="calendar-area">
          <router-outlet></router-outlet>
        </div>

      </div>
    </div>
  </div>
</div>
